import { type PropsWithChildren } from 'react';
import cn from 'clsx';

import styles from './StickyFooter.module.css';

type StickyFooterProps = PropsWithChildren<{
  className?: string;
  isFixed?: boolean;
  isVisible?: boolean;
  'data-testid'?: string;
}>;

export const StickyFooter = ({ className, children, isFixed = false, isVisible = true, 'data-testid': dataTestId }: StickyFooterProps) => {
  return (
    <div
      className={cn(styles.root, isFixed ? styles.fixed : styles.notFixed, isVisible && styles.visible, className)}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};
